"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IInvoiceparameterFrozen = exports.IInvoiceparameterInactive = exports.IInvoiceparameterLocked = exports.IInvoiceparameterType = void 0;
var IInvoiceparameterType;
(function (IInvoiceparameterType) {
    IInvoiceparameterType["THE_APIKEY_THAT_WILL_BE_USED_FOR_THE_INVOICE_APIKEY"] = "apikey";
    IInvoiceparameterType["THE_EMAIL_THE_INVOICE_WILL_BE_SENT_FROM_FROMEMAIL"] = "fromEmail";
    IInvoiceparameterType["_REPLYTOEMAIL"] = "replyToEmail";
    IInvoiceparameterType["NAME_OF_THE_COMPANY_THAT_WILL_SHOWN_ON_INVOICE_DBA"] = "dba";
    IInvoiceparameterType["ADDRESS_SHOWN_ON_INVOICE_ADDRESS1"] = "address1";
    IInvoiceparameterType["ADDRESS_SHOWN_ON_INVOICE_ADDRESS2"] = "address2";
    IInvoiceparameterType["CITY_SHOWN_ON_INVOICE_CITY"] = "city";
    IInvoiceparameterType["STATE_SHOWN_ON_INVOICE_STATE"] = "state";
    IInvoiceparameterType["ZIP_CODE_SHOWN_ON_INVOICE_ZIP"] = "zip";
    IInvoiceparameterType["COUNTRY_SHOWN_ON_INVOICE_COUNTRY"] = "country";
    IInvoiceparameterType["PHONE_SHOWN_ON_INVOICE_PHONE"] = "phone";
    IInvoiceparameterType["WEBSITE_ADDRESS_SHOWN_ON_INVOICE_WEBSITE"] = "website";
    IInvoiceparameterType["THE_TITLE_WHEN_INVOICE_IS_SENT_RECEIPTTITLE"] = "receiptTitle";
    IInvoiceparameterType["THE_MESSAGE_WHEN_INVOICE_IS_SENT_RECEIPTMESSAGE"] = "receiptMessage";
    IInvoiceparameterType["WHETHER_THE_BILLLING_ADDRESS_WILL_BE_REQUIRED_FROM_THE_CUSTOMER_BILLINGREQUIRED"] = "billingRequired";
    IInvoiceparameterType["WHETHER_THE_SHIPPING_ADDRESS_WILL_BE_REQUIRED_FROM_THE_CUSTOMER_SHIPPINGREQUIRED"] = "shippingRequired";
    IInvoiceparameterType["_ECHECKAUTHORIZATION"] = "eCheckAuthorization";
})(IInvoiceparameterType = exports.IInvoiceparameterType || (exports.IInvoiceparameterType = {}));
var IInvoiceparameterLocked;
(function (IInvoiceparameterLocked) {
    IInvoiceparameterLocked[IInvoiceparameterLocked["NOT_LOCKED_0"] = 0] = "NOT_LOCKED_0";
    IInvoiceparameterLocked[IInvoiceparameterLocked["LOCKED_1"] = 1] = "LOCKED_1";
})(IInvoiceparameterLocked = exports.IInvoiceparameterLocked || (exports.IInvoiceparameterLocked = {}));
var IInvoiceparameterInactive;
(function (IInvoiceparameterInactive) {
    IInvoiceparameterInactive[IInvoiceparameterInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    IInvoiceparameterInactive[IInvoiceparameterInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(IInvoiceparameterInactive = exports.IInvoiceparameterInactive || (exports.IInvoiceparameterInactive = {}));
var IInvoiceparameterFrozen;
(function (IInvoiceparameterFrozen) {
    IInvoiceparameterFrozen[IInvoiceparameterFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    IInvoiceparameterFrozen[IInvoiceparameterFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(IInvoiceparameterFrozen = exports.IInvoiceparameterFrozen || (exports.IInvoiceparameterFrozen = {}));
